import { CapabilityMark } from "@/components/ui/capability-mark"
import { Wordmark } from "@/components/ui/wordmark"

/*
 * The auth split's right-hand panel: the board under the lamp, the wordmark
 * at 44px, and the four capabilities as strokes on the print.
 */
const capabilities = [
  { id: "know", verb: "Know", name: "Mental health literacy" },
  { id: "believe", verb: "Believe", name: "Mental health attitudes" },
  { id: "say", verb: "Say", name: "Communication" },
  { id: "do", verb: "Do", name: "Action" },
] as const

export const BoardPanel = () => (
  <div className="board flex h-full w-full flex-col justify-between rounded-2xl p-10">
    <div className="flex flex-col gap-3">
      <Wordmark size={44} className="text-stone-50" />
      <span className="text-onprint-quiet text-2xs tracking-eyebrow font-mono leading-none font-medium uppercase">
        batyr · staff console
      </span>
    </div>

    <div className="flex flex-col gap-8">
      <p className="text-onprint-body max-w-[36ch] text-[15px] leading-relaxed text-pretty">
        The whole product argues towards young people doing. Every screen in
        here is one of four capabilities, drawn on paper.
      </p>
      <ul className="grid grid-cols-2 gap-x-8 gap-y-6 xl:grid-cols-4">
        {capabilities.map((c) => (
          <li key={c.id} className="flex flex-col gap-3">
            <CapabilityMark capability={c.id} size={40} />
            <span className="flex flex-col gap-1">
              <span className="text-[13px] leading-none font-semibold text-stone-50">
                {c.verb}
              </span>
              <span className="text-onprint-quiet text-3xs font-mono leading-[1.4]">
                {c.name}
              </span>
            </span>
          </li>
        ))}
      </ul>
    </div>
  </div>
)
